import type { Fields } from '../../types';
import { FieldTypes } from '../../types/fieldTypes';

// carrier
export const step7: Fields = [
  {
    name: 'Data',
    type: FieldTypes.date,
    code: 99992,
    group: -1, // -1 means carrier group
    errors: ['date', 'required', 'nextWorkingDay'],
    note: 'Il corriere potrebbe passare nei seguenti giorni, scegli quello che ti è più comodo:',
  },
  { name: 'Nome e cognome (c/o)', type: FieldTypes.text, code: 99999, group: -1, errors: ['required'] },
  {
    name: 'Indirizzo',
    type: FieldTypes.text,
    code: 99993,
    group: -1,
    errors: ['required'],
    note: 'Si può anche utilizzare un indirizzo di un TNT point da <a href="https://www.tnt.it/contents/trova-fedex.html" target="new">questa pagina</a>',
  },
  { name: 'CAP', type: FieldTypes.number, code: 99994, group: -1, errors: ['required', 'number'], unit: '' },
  { name: 'Città', type: FieldTypes.text, code: 99995, group: -1, errors: ['required'] },
  {
    name: 'Provincia',
    unit: '2 lettere',
    type: FieldTypes.text,
    transformFn: (value) => value.toString().toUpperCase().slice(0, 2),
    code: 99996,
    group: -1,
    errors: ['required', 'twoLetters'],
  },
  { name: 'Telefono', type: FieldTypes.text, code: 99997, group: -1, errors: ['required'] },
  { name: 'Email', type: FieldTypes.email, code: 99998, group: -1, errors: ['required', 'email'] },
];
